import { render, staticRenderFns } from "./ApplyFormPage.vue?vue&type=template&id=2408c2d3&scoped=true"
import script from "./ApplyFormPage.vue?vue&type=script&lang=js"
export * from "./ApplyFormPage.vue?vue&type=script&lang=js"
import style0 from "./ApplyFormPage.vue?vue&type=style&index=0&id=2408c2d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2408c2d3",
  null
  
)

export default component.exports